import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import Icon from '../Icon';
import CardContext from './CardContext';
const CardStatus = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    children,
    variant,
    icon,
    title,
    actions
  } = _ref;
  const {
    isLoading
  } = useContext(CardContext);
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('pgn__card-status', className),
      "data-testid": "card-status-skeleton",
      ref: ref
    }, /*#__PURE__*/React.createElement(Skeleton, null));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('pgn__card-status', `pgn__card-status__${variant}`, className),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "pgn__card-status__content"
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    className: "pgn__card-status__content-icon",
    src: icon
  }), /*#__PURE__*/React.createElement("div", {
    className: "pgn__card-status__message-content"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "pgn__card-status__heading"
  }, title), children)), !!actions && /*#__PURE__*/React.createElement("div", {
    className: "pgn__card-status__actions"
  }, actions));
});
CardStatus.propTypes = {
  /** Specifies the content of the component. */
  children: PropTypes.node.isRequired,
  /** The class to append to the base element. */
  className: PropTypes.string,
  /** Icon that will be shown in the top-left corner. */
  icon: PropTypes.func,
  /** Specifies variant to use. */
  variant: PropTypes.oneOf(['primary', 'success', 'danger', 'warning']),
  /** Specifies title for the `Card.Status`. */
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  /** Specifies any optional actions, e.g. button(s). */
  actions: PropTypes.node
};
CardStatus.defaultProps = {
  className: undefined,
  icon: undefined,
  variant: 'warning',
  title: undefined,
  actions: undefined
};
export default CardStatus;
//# sourceMappingURL=CardStatus.js.map